const Footer = () => {
  return (
    <footer className="layout-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p>&copy; 2026 Repliqease. All rights reserved.</p>
          <p className="mt-2 text-sm text-[var(--rq-text-soft)]">Organize, search, and assemble your raw material.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
